import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import {
  BrowserRouter as Router,
  Link
} from 'react-router-dom'

// MATERIAL UI STUFF
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class SimpleParagraphWButton extends React.Component {
	render(){
		return(
			<div className="MainDiv">
				<Typography gutterBottom variant="display1" style={{color: '#fff', fontWeight: 500, }}>{this.props.title}</Typography>
                <Typography gutterBottom variant="headline" style={{color: '#fff', fontWeight: 500, lineHeight: '1.2em'}}>{this.props.subtitle}</Typography>
                <Typography variant="subheading" style={{color: '#fff'}}>{this.props.text}</Typography>
                <MainButton /> 
			</div>
			)
	}
}

const MainButton = () =>
<Link style={{textDecoration: 'none'}} to="/portfolio">
    <Button className={css(styles.introButton)}>
        <Grid style={{marginLeft: 20}} container direction="row" alignItems="center" justify="space-between">
            <Grid item>
            Learn More
            </Grid>
                <Grid item>
                    <SvgIcon className={css(styles.rightArrow)}>
                        <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
                    </SvgIcon> 
                </Grid>
        </Grid>
    </Button>
</Link>

const styles = StyleSheet.create({
    introButton: {
        color: 'white',
        width: 180,
        background: 'linear-gradient(-161deg, #4D88FF, #457FDD)',
        borderRadius: 200,
        lineHeight: 0,
        paddingRight: '10px',
        marginTop: '5%',
     	boxShadow: '0 18px 35px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)',
        transition: 'all ease-in-out .2s',
        ':hover':{
            transform: 'translate(0, -2px)',
            boxShadow: '0 20px 40px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#457FDD',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Utilities/SimpleParagraphWButton.js